import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeUntil, first } from "rxjs/operators";
import { BehaviorSubject, Subject } from "rxjs";

import { User, Role } from "app/auth/models";
import { AuthenticationService } from "app/auth/service";
import { CoreConfigService } from "@core/services/config.service";
import { CoreMenuService } from "@core/components/core-menu/core-menu.service";
import { ToastrService } from "ngx-toastr";

@Component({
	selector: "app-auth-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
	//  Public
	public coreConfig: any;
	public loginForm: FormGroup;
	public loading = false;
	public submitted = false;
	public returnUrl: string;
	public error = "";
	public passwordTextType: boolean;
	private currentUserSubject: BehaviorSubject<User>;

	// Private
	private _unsubscribeAll: Subject<any>;

	/**
	 * Constructor
	 *
	 * @param {CoreConfigService} _coreConfigService
	 */
	constructor(
		private authService: AuthenticationService,
		private _coreConfigService: CoreConfigService,
		private _formBuilder: FormBuilder,
		private _route: ActivatedRoute,
		private _router: Router,
		private _authenticationService: AuthenticationService,
		private _coreMenuService: CoreMenuService,
	) {
		if (this._authenticationService.currentUserValue) {
			this._router.navigate(["/cliente"]);
		}

		this.currentUserSubject = new BehaviorSubject<User>(
			JSON.parse(localStorage.getItem("currentUser"))
		);
		this._unsubscribeAll = new Subject();

		// Configure the layout
		this._coreConfigService.config = {
			layout: {
				navbar: {
					hidden: true,
				},
				menu: {
					hidden: true,
				},
				footer: {
					hidden: true,
				},
				customizer: false,
				enableLocalStorage: false,
			},
		};
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.loginForm.controls;
	}

	/**
	 * Toggle password
	 */
	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}

	onSubmit() {
		this.submitted = true;

		if (this.loginForm.invalid) {
			return;
		}

		this.loading = true;
		this._authenticationService
			.login(this.f.email.value, this.f.password.value)
			.pipe(first())
			.subscribe(
				(user) => {
					if (user) {

						this._authenticationService
							.token_api(this.f.email.value, this.f.password.value)
							.pipe(first())
							.subscribe(
								(token) => {
									localStorage.setItem('currentUser', JSON.stringify(user));
									localStorage.setItem('tokenApiG2E', token.access_token);
									localStorage.setItem("userPermissions", JSON.stringify(user.permissao));
									// Carrega o menu agora que o token existe — sem isso ele
									// so aparecia apos um refresh manual da pagina.
									this._coreMenuService.carregarMenus();
									this._router.navigate([this.returnUrl]);
								}
							);
					} else {
						this.error = 'Credenciais Invalidas.';
						this.loading = false;
					}
				},
				(error) => {
					console.log(error);
					this.error = 'Erro interno. Tente novamente.';
					this.loading = false;
				}
			);
	}
	// Lifecycle Hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		let user = JSON.parse(localStorage.getItem("currentUser"));
		if (user != null) {
			this.authService.logout(user.email);
		}

		this.loginForm = this._formBuilder.group({
			email: ["", [Validators.required, Validators.email]],
			password: ["", Validators.required],
		});

		// get return url from route parameters or default to '/'
		this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/cliente";

		// Subscribe to config changes
		this._coreConfigService.config
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((config) => {
				this.coreConfig = config;
			});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
